import Agreement from "../../../components/Terms/Agreement";

const AgreementPage = () => {
    return (
        <Agreement></Agreement>
    );
}

export default AgreementPage;
